import { propsFactory } from "@soft-db/soft-utils";
import { computed, type ExtractPropTypes, type PropType } from "vue";
import type { SerieScaleOptions, XAxisSide, YAxisSide } from "../interfaces";
import { useCartesianChart } from "./cartesian-chart";

export const serieScaleProps = propsFactory<SerieScaleOptions>()({
	xAxis: {
		type: String as PropType<XAxisSide>,
		default: "bottom",
	},
	yAxis: {
		type: String as PropType<YAxisSide>,
		default: "left",
	},
});

type SerieScaleProps = ExtractPropTypes<typeof serieScaleProps>;

export const useSerieScale = (props: SerieScaleProps) => {
	const { scales } = useCartesianChart();

	const xScale = computed(() => {
		const { xAxis } = props;

		return scales.value[xAxis];
	});

	const yScale = computed(() => {
		const { yAxis } = props;

		return scales.value[yAxis];
	});

	return { xScale, yScale };
};
